import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";

export const normalizeHomeScreenSections = (data) => {
    const payload = data?.data ?? data;

    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.list)) return payload.list;
    if (payload?.id) return [payload];

    return [
        ...(payload?.header || []),
        ...(payload?.section || []),
        ...(payload?.footer || [])
    ];
};

export const SectionServices = {
    sectionList: async (data) => {
        const queryParams = new URLSearchParams();
        queryParams.append('page', data.page + 1);
        queryParams.append('limit', data.limit);
        queryParams.append('pageType', data.pageType);
        queryParams.append('searchKey', data.filters?.searchKey || '');
        if (data.filters?.sortBy) {
            queryParams.append('sortBy', data.filters.sortBy);
            queryParams.append('sortType', data.filters.sortType || 'ASC');
        }
        if (data.filters?.filterOptions) {
            data.filters.filterOptions.forEach((filter, index) => {
                if (filter.fieldName && filter.value) {
                    queryParams.append(`filters[${index}][fieldName]`, filter.fieldName);
                    queryParams.append(`filters[${index}][operator]`, filter.operator);
                    queryParams.append(`filters[${index}][value]`, filter.value);
                    if (index !== 0) {
                        queryParams.append(`filters[${index}][andOr]`, filter.andOr);
                    }
                }
            });
        }
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/list?${queryParams.toString()}`, {}, Helpers.token());
    },

    fetchSectionList: async (data = {}) => {
        const queryParams = new URLSearchParams();
        if (data.pageType) {
            queryParams.append('pageType', data.pageType);
        }
        if (data.sortBy) {
            queryParams.append('sortBy', data.sortBy);
            queryParams.append('sortType', data.sortType || 'ASC');
        }
        const queryString = queryParams.toString();
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/all${queryString ? `?${queryString}` : ''}`, {}, Helpers.token());
    },
    
    getSectionById: async (id) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/details/${id}`, {}, Helpers.token());
    },
    
    addSection: async (data) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/manage-customer-app/section/add`, data, Helpers.token());
    },
    
    updateSection: async (id, data) => {
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/manage-customer-app/section/update/${id}`, data, Helpers.token());
    },
    
    toggleStatus: async (id) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/modify-status/${id}`, {}, Helpers.token());
    },
    
    deleteSection: async (id) => {
        return await commonRequest("DELETE", `${Helpers.URL()}/api/admin/manage-customer-app/section/delete/${id}`, {}, Helpers.token());
    },
    
    reorderSections: async (data) => {
        return await commonRequest("PUT", `${Helpers.URL()}/api/admin/manage-customer-app/section/reorder`, data, Helpers.token());
    },

    homeScreenPreview: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/manage-customer-app/section/home-screen-preview`, {}, Helpers.token());
    },

    normalizeHomeScreenSections
};
